import { withLazy } from './components/lazy'

export const App = withLazy(() => import('./app'))
